'use client';

import trailerDialogStyles from '@/components/dialogs/trailer-dialog/trailer-dialog.module.scss';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { useDataAnalytics } from '@/hooks/analytics/analytics';

type MovieRewardsVideoDialogProps = {
  children: React.ReactNode;
};

export const MovieRewardsVideoDialog = ({ children }: Readonly<MovieRewardsVideoDialogProps>): React.JSX.Element => {
  const { trackClick } = useDataAnalytics();

  return (
    <Dialog>
      <DialogTrigger asChild
        onClick={() => trackClick({
          linkCategory: AnalyticsPageCategories.MOVIE_REWARDS,
          linkName: 'Movie Rewards Video Play',
        })}
      >
        {children}
      </DialogTrigger>
      <DialogContent className={trailerDialogStyles['modal-content']}>
        <DialogHeader showCloseButton={false}>
          <DialogTitle className="sr-only">Cinemark Movie Rewards video</DialogTitle>
        </DialogHeader>
        <DialogDescription className="sr-only">Cinemark Movie Rewards video</DialogDescription>
        <div className="relative -mt-4 aspect-video w-full">
          <iframe allowFullScreen
            allow="autoplay; encrypted-media"
            className="absolute top-0 left-0 h-full w-full"
            src="https://www.youtube.com/embed/0SLhsol2HFA?autoplay=1"
            title="Cinemark Movie Rewards video"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
